import PGSHelper from "../../helpers/PGSHelper.js";
let pgsHelper = new PGSHelper();
import _ from "lodash";
import { fontStringify } from "pdfmake/src/helpers.js";
export default class ReporteRondasPrepagadas {
  constructor() {}

  static getDocData(mainData) {
    /*let tenderTable = this.getTenderTable(contadores, mPagos)
    let familiasTable = this.getFamiliasTable(familias);
    let otrosTable = this.getOtrosTable(contadores, mPagos)*/
    let getTable = this.getTable(mainData.data);

    let imgColumn = {
      // star-sized columns fill the remaining space
      // if there's more than one star-column, available width is divided equally

      text: "",
      width: "10%",
    };
    let docDefinition = {
      pageMargins: [20, 20, 20, 20],
      pageOrientation: "portrait",
      content: [
        //header
        {
          columns: [
            {
              // fixed width
              width: "100%",
              alignment: "center",
              bold: true,
              text: [mainData.TITLE + "\n"],
            },
          ],
        },
        {
          columns: [
            //     {
            //       // fixed width
            //       width: "35%",
            //       alignment: "left",
            //       bold: true,
            //       text: ["DEL " + mainData.FI + "\n", "A " + mainData.FF + "\n"],
            //     },
            //     {
            //       // fixed width
            //       width: "35%",
            //       alignment: "left",
            //       bold: true,
            //       text: [],
            //     },
            {
              // % width
              width: "30%",
              bold: true,
              text: [
                "Generado: " + mainData.FG + "\n",
                "Hora Generado: " + mainData.HG + "\n",
              ],
            },
          ],
          // optional space between columns
          columnGap: 10,
        },
        {
          columns: [
            {
              // fixed width
              width: "100%",
              table: {
                widths: ["*",70,70],
                heights: 25,
                body: getTable,
              },
            },
          ],
          margin: [0, 0, 0, 0],
        },
      ],
    };
    return docDefinition;
  }

  static getTable(data) {
    let headers = [
      {
        text: "Nombre",
        border: [true, true, true, true],
        fontSize: 12,
        alignment: "center",
      },
      {
        text: "Rondas Disponibles",
        border: [true, true, true, true],
        fontSize: 12,
        alignment: "center",
      },
      {
        text: "Rondas reservadas",
        border: [true, true, true, true],
        fontSize: 12,
        alignment: "center",
      },
      
    ];

    let times = [headers];

    data.forEach((time) => {
      let rowToAdd = [];

      rowToAdd = [
        {
          text: ["\n" + time.NombreCompleto + "\n"],
          fontSize: 12,
          alignment: "left",
        },
        {
          text: time.CuponesDisponibles,
          fontSize: 12,
          alignment: "center",
        },
        {
          text: time.CuponesReservados,
          fontSize: 12,
          alignment: "center",
        },
      ];
      times.push(rowToAdd);
    });
    
    return times;
  }

  static getFirmas(data, porcentaje) {
    let times = [
      [
        { text: "Mesero", border: [true, true, true, true], fontSize: 12 },
        { text: "Total", border: [true, true, true, true], fontSize: 12 },
        {
          text: "%" + porcentaje,
          border: [true, true, true, true],
          fontSize: 12,
        },
        { text: "Firma", border: [true, true, true, true], fontSize: 12 },
      ],
    ];
    data.forEach((venta) => {
      let rowToAdd = [];
      if (venta.tipo == "footer") {
        rowToAdd = [
          {
            text: venta.Mesero,
            border: [true, true, true, true],
            fontSize: 10,
          },
          {
            text: "$" + pgsHelper.formatNumber(venta.Total),
            bold: true,
            border: [true, true, true, true],
            fontSize: 10,
            alignment: "right",
          },
          {
            text:
              "$" +
              pgsHelper.formatNumber((venta.Total * Number(porcentaje)) / 100),
            bold: true,
            border: [true, true, true, true],
            fontSize: 10,
            alignment: "right",
          },
          {
            text: " ",
            bold: true,
            border: [true, true, true, true],
            fontSize: 10,
            alignment: "center",
          },
        ];
        times.push(rowToAdd);
      }
    });

    let table = {
      border: [true, false, true, true],
      widths: ["*"],
      heights: 60,
      table: {
        body: times,
      },
    };

    return times;
  }
}
